
import { defineComponent, ref, onMounted } from "vue";
import { useStore } from "vuex";

import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "invoices",
  props: {
    cardClasses: String,
  },
  components: {
    Datatable,
  },
  setup() {
    const store = useStore();
    const orders: any = ref({
      data: [],
      meta: {
        total: 0,
      },
    });

    const tableHeader = ref([
      {
        name: "Order id",
        key: "id",
        sortable: true,
      },
      {
        name: "Customer id",
        key: "customer_id",
        sortable: true,
      },
      {
        name: "Total",
        key: "total",
        sortable: true,
      },
      {
        name: "Date",
        key: "created_at",
        sortable: true,
      },
    ]);

    const loading = ref(true);
    const pagination = ref({
      page: 1,
      rowsPerPage: 5,
    });
    const sort = ref({
      columnName: "",
      order: "",
    });

    onMounted(() => {
      setTimeout(async () => {
        orders.value = await getOrders(pagination.value, sort.value);
        loading.value = false;
      }, 1000);
    });

    const getOrders = async (pagination, sort) => {
      try {
        const { page, rowsPerPage } = pagination;
        const offset = (page - 1) * rowsPerPage;

        let sortParam = "";
        const { columnName, order } = sort;
        if (columnName !== "") {
          sortParam = `&sort=${columnName},${order}`;
        }

        let url = `customers/orders?customer_id=${store.getters.currentUser.data.customer_id}&offset=${offset}&limit=${rowsPerPage}${sortParam}`;

        const { data } = await ApiService.get(url);
        return data;
      } catch (err) {
        return {
          data: [],
          meta: {
            total: 0,
          },
        };
      }
    };

    const onCurrentChange = async (val) => {
      pagination.value.page = val;

      loading.value = true;
      orders.value = await getOrders(pagination.value, sort.value);
      loading.value = false;
    };

    const onSort = async (val) => {
      sort.value = val;

      loading.value = true;
      orders.value = await getOrders(pagination.value, sort.value);
      loading.value = false;
    };

    return {
      tableHeader,
      orders,
      loading,
      onCurrentChange,
      onSort,
    };
  },
});
